import React, { useContext, useEffect } from "react";
import AppContext from "../context/context";
import { Container, Ad, Note, FlexCenter, Footers } from "../styles/fundStyles";
import logo from "../assets/images/fundapp/logo.webp";
import icon from "../assets/images/fundapp/back.webp";
import ad from "../assets/images/fundapp/ad.webp";
import u from "../assets/images/fundapp/u.webp";
import ass from "../assets/images/fundapp/ass.webp";
import persona from "../assets/images/fundapp/persona.webp";
import i1 from "../assets/images/fundapp/i1.webp";
import i2 from "../assets/images/fundapp/i2.webp";
import i3 from "../assets/images/fundapp/i3.webp";
import i4 from "../assets/images/fundapp/i4.webp";
import i5 from "../assets/images/fundapp/i5.webp";
import i6 from "../assets/images/fundapp/i6.webp";
import i7 from "../assets/images/fundapp/i7.webp";
import i8 from "../assets/images/fundapp/i8.webp";
import rec from "../assets/images/fundapp/rec.webp";
import { Link } from "react-router-dom";

export const BackIcon = () => {
  return (
    <div className="icon-hol">
      <Link to="/">
        <img src={icon} alt="icon" className="icon" />
      </Link>
    </div>
  );
};
function Fundapp() {
  const { setTopOn } = useContext(AppContext);
  useEffect(() => {
    setTopOn(true);
  }, [setTopOn]);
  return (
    <Container>
      <div className="margin-con">
        <div className="top">
          <img src={logo} alt="logo" className="logo" />
          <BackIcon />
        </div>
        <Ad id="ad">
          <img src={ad} alt="ad" className="ad" />
          <img src={u} alt="u" className="u" />
          <div className="title">
            <h2>Product Designer</h2>
            <img src={ass} alt="ass" className="ass" />
          </div>
        </Ad>
        <Note id="disclaimer">
          <img src={u} alt="U" className="u" />
          <h1>The Disclaimer</h1>
          <p>
            This REDESIGN is a feedback to the Assessment. Under no
            cirmcumstance does this reflect on Fundall’s goal(s) or mission.
            Furthermore, this does not intend to undermine the Fundall brand.
          </p>
          <p>
            It expresses what I feel could be improved on to enable users enjoy
            using the app, thus increasing return on investments.
          </p>
        </Note>
        <Note id="challenge">
          <img src={u} className="u" alt="U" />
          <h1>The Challenge</h1>
          <ul>
            <li>
              Identify a Target User not being well served and redesign product
              to appeal to the User.{" "}
            </li>
            <li>
              {" "}
              Create virality and community effect within this target user's
              audience.
            </li>
          </ul>
        </Note>
        <Note id="persona">
          <img src={u} className="u" alt="U" />
          <h2>
            User Persona <span>(Target User)</span>
          </h2>
          <img src={persona} alt="persona" className="persona" />
          <div className="text">
            <h2>Problem Statement</h2>
            <p>
              Olusho can be classified as a NBU (Next Billion Users) becuase of
              his lack of experience with tech products. They need a means to
              meet some financials needs as quickly and easily as possible
              because of their tight schedule.
            </p>
          </div>
        </Note>
        <Note id="issues">
          <img src={u} className="u" alt="U" />
          <h1>The issues</h1>
          <FlexCenter className="flex-center">
            <img src={i1} alt="fund 1" />
            <div className="des-text">
              <div className="cta">
                <h3>A. CTA Buttons</h3>
                <p>
                  Call to action buttons are not clearly defined which could
                  lead to confusion about the next line of action to take to
                  proceed to the Homepage.
                </p>
              </div>
              <div className="cta">
                <h3>Alternative Log-in Option</h3>
                <p>
                  It could be quite a task for the User to have to fill in all
                  the details. An option should be made for Email or Social
                  media accounts e.g Facebook Login which could easily help fill
                  some information thereby improving Success rates.
                </p>
              </div>
            </div>
            <img src={i2} alt="fund 2" />
          </FlexCenter>
        </Note>
        <Note id="issues">
          <img src={u} className="u" alt="U" />
          <h1>The issues</h1>
          <FlexCenter className="flex-center">
            <img src={i3} alt="fund 3" />
            <div className="des-text">
              <div className="cta">
                <h3>B. Clarity in Instructions</h3>
                <p>
                  How would you like to? Tell me your primary money needs...
                  These statements are not descriptive enough for the actions to
                  be taken. A more direct instruction like “Select the actions
                  you would need” or something close to that describes the
                  action to be taken better.
                </p>
              </div>
              <div className="cta">
                <h3>C. Categorizing Choices</h3>
                <p>
                  There is simple idea called Hick’s Law that says that the more
                  choices you present your users with, the longer it will take
                  them to reach a decision. It would have been less overwhelming
                  if the choices to be made were grouped in categories of
                  similar uses, this could help in improving speed of Time to
                  goal.
                </p>
              </div>
              <div className="cta">
                <h3>D. Navigations</h3>
                <p>
                  When clicked upon, the Navigation Icons barely show any sign
                  of being active, a user with low vision might have difficulty
                  knowing when a different segment has been selected. It can be
                  improved upon by changing the form of the icon when selected.
                </p>
              </div>
            </div>
            <img src={i4} alt="fund 4" />
          </FlexCenter>
        </Note>
        <Note id="issues">
          <img src={u} className="u" alt="U" />
          <h2>
            The issues <span>(Addressing Virality & Community)</span>
          </h2>
          <FlexCenter className="flex-center">
            <img src={i5} alt="fund 3" />
            <div className="des-text">
              <div className="cta">
                <h3>Make Incentives obvious</h3>
                <p>
                  The positioning of the location of the icon to get Referral
                  Bonus though bold, could be made more evident by moving it to
                  the top of this list
                </p>
              </div>
              <div className="cta">
                <h3>Information Hierarchy</h3>
                <p>
                  Also, it just feels like the information priority here is out
                  of place. Proper organization will help Time to goal.
                </p>
              </div>
            </div>{" "}
            <img src={i6} alt="fund 4" />
          </FlexCenter>
        </Note>
        <Note id="Solutions">
          <img src={u} className="u" alt="U" />
          <h1>The Solutions</h1>
          <FlexCenter className="flex-center">
            <img src={i7} alt="fund 3" />
            <div className="des-text">
              <div className="cta">
                <h3>A. CTA Buttons</h3>
                <p>
                  Call to action buttons are clearly defined which will
                  facilitate clarity in next line of action
                </p>
              </div>
              <div className="cta">
                <h3>Alternative Log-in Option</h3>
                <p>This is closer to current trends (in the industry)</p>
              </div>
              <div className="cta">
                <h3>B. Clarity in Instructions</h3>
                <p>
                  The Statement is easier to decipher due to clearer
                  instructions
                </p>
              </div>
              <div className="cta">
                <h3>C. Categorizing Choices</h3>
                <p>
                  The Tab bar pattern will help categorize similar contents.
                </p>
              </div>
            </div>
            <img src={i8} alt="fund 4" />
          </FlexCenter>
        </Note>
        <Footers>
          <img src={rec} alt="rec" className="rec" />
          <img src={logo} alt="logo" className="logo" />
          <h1>The Results</h1>
          <div className="overlay">
            <p>Overall Increase in Usability to address neglected Users</p>
            <p className="s">
              Improved interface with minimal interference with the initial feel
              of the <br />
              product
            </p>
          </div>
        </Footers>
      </div>
    </Container>
  );
}

export default Fundapp;
